<template>
  <div>
    <form v-if="!loading">
      <div
        v-for="(group, groupIndex) in attributesFields.attributeGroups"
        class="group"
        :key="groupIndex"
        :group="group"
      >
        <h1 class="ttl">{{ group.name }}</h1>
        <div
          class="grid 2xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-4 p-6"
        >
          <!-- {{ group.productAttributes.length }} -->
          <div
            v-for="(
              productAttribute, productAttributeIndex
            ) in group.productAttributes"
            :key="productAttribute"
            class="col-span-1 flex items-end"
          >
            <vs-input
              class="w-full"
              :value="productAttribute.stringValue"
              @input="
                stringValueChanged($event, productAttributeIndex, groupIndex)
              "
              name="productAttribute"
              :label="productAttribute.attributeName"
              v-if="productAttribute.type === 'Text'"
            />
            <div class="w-full" v-if="productAttribute.type === 'Single'">
              <span class="text-sm">{{ productAttribute.attributeName }}</span>
              <v-select
                label="value"
                name="singleOption"
                :options="productAttribute.singleOptions"
                :value="
                  productAttribute.singleOptions.filter(
                    (z) => z.checked == true
                  )
                "
                @input="
                  (x) =>
                    singleOptionsChanged(
                      x,
                      productAttribute,
                      productAttributeIndex,
                      groupIndex
                    )
                "
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="w-full" v-if="productAttribute.type === 'Selctive'">
              <span>{{ productAttribute.attributeName }}</span>
              <v-select
                label="value"
                name="selectiveOption"
                :options="productAttribute.selectiveOptions"
                :value="
                  productAttribute.selectiveOptions.filter(
                    (z) => z.checked == true
                  )
                "
                @input="
                  (x) =>
                    selectiveOptionsChanged(
                      x,
                      productAttribute,
                      productAttributeIndex,
                      groupIndex
                    )
                "
                dir="rtl"
                multiple
              >
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          attributes.attributeGroups && attributes.attributeGroups.length > 0
        "
      >
        <vs-button
          class="mr-3 mb-6 submit-btn bg_l_green"
          @click.prevent="submitFeature"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </div>
      <div v-if="attributes.attributeGroups == null" class="bg-info">
        فاقد مشخصات!
      </div>
    </form>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      attributesFields: {},
      disabled: false,
      sample: "",
    };
  },
  computed: {
    ...mapGetters({
      attributes: "attributes/details",
      loading: "attributes/loading",
    }),
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchAttributesById: "attributes/fetchAttribuesById",
      updateAttributeValues: "attributes/updateAttributeValues",
      setProductAttributeSelectiveOptionsChecked:
        "attributes/setProductAttributeSelectiveOptionsChecked",
      setProductAttributeSingleOptionsChecked:
        "attributes/setProductAttributeSingleOptionsChecked",
      setProductAttributeStringValue:
        "attributes/setProductAttributeStringValue",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchAttributesById(id).then(() => {
        this.attributesFields = Object.assign({}, this.attributes);
      });
    },
    singleOptionsChanged(val, pa, productAttributeIndex, groupIndex) {
      this.setProductAttributeSingleOptionsChecked({
        val,
        pa,
        productAttributeIndex,
        groupIndex,
      });
    },
    selectiveOptionsChanged(val, pa, productAttributeIndex, groupIndex) {
      this.setProductAttributeSelectiveOptionsChecked({
        val,
        pa,
        productAttributeIndex,
        groupIndex,
      });
    },
    stringValueChanged(val, productAttributeIndex, groupIndex) {
      this.setProductAttributeStringValue({
        val,
        productAttributeIndex,
        groupIndex,
      });
    },
    submitFeature() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.updateAttributeValues(this.attributesFields).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
